export default {
  fi: {
    ServiceEventEditScene: {
      editServiceEvent: 'Muokkaa huoltoa',
    },
  },
};
